import { createSelector } from '@reduxjs/toolkit';

export const createParameterSelector = (selector) => (_, params) => {
  return selector(params);
};

const selectShared = (state) => state.shared || {};

export const selectSliceFromShared = (sliceName, initialState) =>
  createSelector(selectShared, (shared) => shared[sliceName] || initialState);
